import { memo, useState } from 'react';
import clsx from 'clsx';
import Image from 'next/image';

import { Deal } from '~/types/deal';
import ChevronDown from '~/public/font-awesome/chevron-down-black-pearl.png';

import AverageRating from './sidebar/AverageRating';
import BreakoutRating from './sidebar/BreakoutRating';

const CHEVRON_ICON_SIZE = 16;

function CollapsibleRatings({
  deal,
  openByDefault = true,
}: {
  deal: Deal;
  openByDefault?: boolean;
}) {
  const [isExpanded, setIsExpanded] = useState(openByDefault);

  const iconClassName = clsx(
    'text-right transition duration-100 ease-in-out',
    isExpanded && 'rotate-180',
  );

  return (
    <div className="border-b border-b-gravel pb-4">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex w-full items-center justify-between gap-2 font-semibold"
      >
        <span>Ratings</span>
        <Image
          src={ChevronDown}
          alt="expand"
          width={CHEVRON_ICON_SIZE}
          height={CHEVRON_ICON_SIZE}
          className={iconClassName}
        />
      </button>

      {isExpanded && (
        <div className="mt-4 max-w-[351px]">
          <AverageRating
            average={deal.deal_review.average_rating}
            count={deal.deal_review.review_count}
          />

          <BreakoutRating dealReview={deal.deal_review} />
        </div>
      )}
    </div>
  );
}

export default memo(CollapsibleRatings);
